export default "__VITE_ASSET__DvnkDWwa__"